export default __webpack_public_path__ + "static/media/manCheckedIcon.9a30cffd.svg";